import { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';

import { cn } from "cn";

/** Groups accordion panels so `not-last:border-b-0` can leave a bottom border on the final item. */
export function AccordionGroup({ className, ...props }: React.ComponentProps<'div'>) {
    return <div className={cn(className)} {...props} />;
}

export default function AccordionComponent(props: { title: string | React.ReactNode; children: React.ReactNode; defaultExpanded?: boolean; expanded?: boolean; onChange?: () => void }) {
    const { title, children, defaultExpanded, expanded, onChange } = props;
    const [uncontrolledOpen, setUncontrolledOpen] = useState(Boolean(defaultExpanded));
    const isControlled = expanded !== undefined;
    const open = isControlled ? expanded : uncontrolledOpen;

    function toggle() {
        if (onChange) {
            onChange();
            return;
        }
        setUncontrolledOpen((prev) => !prev);
    }

    const titleId = typeof title === 'string' ? `${title}-header` : 'accordion-header';
    const contentId = typeof title === 'string' ? `${title}-content` : 'accordion-content';

    return (
        <div className="border border-black/10 not-last:border-b-0">
            <h3 className="m-0">
                <button
                    type="button"
                    id={titleId}
                    aria-controls={contentId}
                    aria-expanded={open}
                    onClick={toggle}
                    className="sticky top-0 z-100 flex w-full items-center justify-between bg-gray-300 px-4 py-3 text-left text-sm font-bold outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
                >
                    <span>{title}</span>
                    <ChevronDownIcon className={cn('size-5 shrink-0 text-muted-foreground transition-transform', open && 'rotate-180')} />
                </button>
            </h3>
            <div id={contentId} role="region" aria-labelledby={titleId} hidden={!open} className={cn('border-t border-black/10 p-4', !open && 'hidden')}>
                {children}
            </div>
        </div>
    );
}
